import { SetFilterAction, FilterState } from "../types";

export const SET_FILTER = "SET_FILTER";

export const setFilter = (value: FilterState): SetFilterAction => {
  return {
    type: SET_FILTER,
    value,
  };
};
